<template>
  <div id="app">
	  <transition name="fade">
		  <main-map v-if="loadMap" :class="{'map-hidden': !mapVisible}" />
	  </transition>
	  <transition appear :name="transitionName">
		  <keep-alive>
			  <router-view/>
		  </keep-alive>
	  </transition>
	  <div class="offline-notice" v-show="offline">网络连接不可用</div>
  </div>
</template>

<script>
import MainMap from "./components/main-map/index";
import {mapGetters} from 'vuex';
import {baiduToMars, isIos, isWX, loadScriptOnce,isChelaile, isNanNingApp, setTitle, isThirdCommonLoginApp} from "./utils";
import inobounce from 'inobounce';
import to from 'await-to-js';
import { getUrlParams } from './utils/index'
import channelMgr from './service/channel'
import { ls } from "./store/local-store";

export default {
	components: {
		MainMap
	},
	data() {
		return {
			loadMap: true,
			offline: false
		};
	},
	computed: {
		...mapGetters({
			user: 'user/user',
      ticketConfig: 'config/ticketConfig',
		}),
		transitionName() {
			return this.$getRouteMeta(this.$route, 'transition');
		},
		mapVisible() {
			return this.$store.state.map.state.mapVisible;
		},
		query() {
			return this.$route.query || {};
		}
	},
	created() {
		if (isIos()) {
			inobounce.enable();
		}
		this.$AppService.devTools();
	},
  beforeMount() {
		console.log('beforeMount', window.location.href);
    // 车来了app联合登录
		if (isChelaile()) {
      setTimeout(() => {
        window.requestAnimationFrame(() => {
          this.loading = true;
            this.cllInit();
        });
			}, 1000);
		} else if (isNanNingApp() || isThirdCommonLoginApp()) {
			console.log('监测到是第三方登录app');
			const code = getUrlParams('code')
			const from = getUrlParams('from')
			const cityId = getUrlParams('cityId') || ls.getItem('cityId')
			this.updateUserInfoByCode({ from, code, cityId })
		}
	},
	mounted() {
		this.$nextTick(async () => {
			const linePromotionId = getUrlParams('lp')
			if (linePromotionId) {
				channelMgr.setChannelInfo({ linePromotionId })
			}
			let {sessionId, cityId} = this.query || {};
      cityId = cityId || getUrlParams('cityId')
			setTitle()
			if (isWX()) {
				console.log('监测到是微信环境');
				console.log('获取链接中的sessionId:', sessionId);
				if (sessionId) {
					this.$UserService.setSessionId(sessionId);
				}
				console.log('清理地图缓存');
				Object.keys(localStorage).forEach(key => {
					if (key.startsWith("_AMap_")) {
						localStorage.removeItem(key);
					}
				});
			}
			this.$AppService.setCityId(cityId);
			this.$AppService.setCityName(this.$AppService.getCityNameById(cityId));
			this.loadMap = true;
			this.$AppService.recoverCityId();
			this.$UserService.recoverLocal();
			setTitle()
      // 获取页面参数
      this.$HomeService.fetchConfig({cityId}).then(() => {
        if (this.ticketConfig.pageTitle) {
					setTitle(this.ticketConfig.pageTitle)
        }
      })
			// 获取城市参数
			this.$HomeService.fetchCityConfig({cityId})
      // 超过2s不再等待定位，继续执行下面代码
      let loc = await Promise.race([this.$MapService.getLocation(), new Promise(resolve => {
        setTimeout(resolve, 2000)
      })]);
      console.log('loc', loc)
      if (typeof loc === 'number') loc = [];
      const [lng, lat] = loc || [];
			const marsPos = baiduToMars(lng, lat);

			// 拉取运营信息
			this.$HomeService.fetchAreas({lng: marsPos.lng, lat: marsPos.lat}).then(async (data) => {
				if (!data || !data.length) {
					this.$cheToast({
						type: 'fail',
						text: '当前暂无运营区域'
					});
					this.$MapService.setMapCity(this.$AppService.getCityName());
				}
				// 将所有的运营区域、站点、运营时间等信息存入运营服务
				this.$RunService.setAreas(data);
				// 设置默认区域，不可省略
				this.$RunService.setCurrentArea(0, false);
        // 一键叫车浮窗
				const userId = this.$UserService.getUserId()
				if (userId) {
					this.$HomeService.fetchReactiveCall({
						cityId: this.$AppService.getCityId(),
						userId,
						lat: marsPos.lat,
						lng: marsPos.lng
					})
				}
				// 获取默认区域索引
				const {areaIndex, isAreaPop} = await this.$RunService.fetchDefaultAreaIndex(this.$AppService.getCityId(), marsPos.lng, marsPos.lat, this.$UserService.getUserId());
        if (areaIndex !== -1 && typeof areaIndex === 'number') {
					// 默认选中区域
					this.$RunService.setCurrentArea(areaIndex);
					this.$nextTick(() => {
						this.$store.dispatch('run/setDefaultAreaState', true)
					})
        }
				if (isAreaPop) {
					// 服务器未返回默认区域，让用户自己选
					this.$HomeService.setAreaPickerVisible(true);
				}
			}).catch(res => {
				console.error(res);
			});
			window.addEventListener('online', () => {
				this.offline = false;
			});

			window.addEventListener('offline', () => {
				this.offline = true;
			});

		});
	},
	beforeDestroy() {
		inobounce.disable();
	},
  methods: {
    async updateUserInfoByCode({ from ,code, cityId }) {
      if (from && code) {
        const [err, res] = await to(this.$UserService.fetchUserInfoByCode({
					sourceFrom: from,
					code,
					cityId
				}))
        const { mobile, userId, isServiceManager, baseLineId } = res || {}
        if (userId) {
          const info = {
            id: userId,
            mobile,
            isServiceManager: isServiceManager === 1,
            supportAreaIds: (baseLineId || '').split(',').map(p => parseInt(p))
          }
          const userInfo = this.$UserService.getUser()
          const user = {...userInfo, ...info}
          this.$UserService.setUser(user)
        }
        console.error('updateUserInfoByCode err:', err, this.$UserService.getUser())
      }
    },
    async updateUserInfo(mobile) {
      if (mobile) {
        const [err, res] = await to(this.$UserService.fetchUserInfoByPhone({mobile}))
        const { userId, isServiceManager, baseLineId   } = res || {}
        if (userId) {
          const info = {
            id:userId,
            mobile,
            isServiceManager: isServiceManager === 1,
            supportAreaIds: (baseLineId || '').split(',').map(p => parseInt(p))
          }
          const userInfo = this.$UserService.getUser()
          const user = {...userInfo, ...info}
          this.$UserService.setUser(user)
        }
        console.log('fetchUserInfoByPhone err:', err, this.$UserService.getUser())
      }
    },
    // 车来了
		cllInit() {
			loadScriptOnce('cll', 'https://cdn.web.chelaile.net.cn/cll-sdk-js/cll-2269077fae.js').then(() => {
				let i = 0;
				let timer = setInterval(() => {
					if (window.cll || i > 10) {
						clearInterval(timer);
						timer = null;
						this.loading = false;
						this.getCllUdid(window.cll).then(udid => {
							window.cll.getUserInfo({
								success: user => {
									console.log('user', user);
									this.cllLogin(user, udid);
								},
								fail: () => {
									this.jumpToCllLogin(window.cll, udid);
								},
							});
						});
					}
					i++;
				}, 1000);
			});
		},
		// 获取车来了app用户udid
		getCllUdid(cll) {
			return new Promise((resolve, reject) => {
				cll.getLocalInfo({
					success: res => {
						const {udid} = res;
						resolve(udid);
					},
					fail: () => {
						reject();
					},
				});
			});
		},
		// 跳转至车来了app登录页面
		jumpToCllLogin(cll, udid) {
			cll.userLogIn({
				data: {
					agreementText: '绑定手机号',
				},
				success: user => {
					console.log('login success', user);
					this.cllLogin(user, udid);
				},
				fail: res => {
					console.log('login fail', res);
					this.cllClose(cll);
				},
				cancel: () => {
					console.log('login cancel');
					this.cllClose(cll);
				},
			});
		},
		// 车来了 三方登录
		cllLogin(user) {
			const {phoneNumber: mobile} = user || {};
      this.updateUserInfo(mobile)
		},
		// 车来了app 关闭h5页面
		cllClose(cll) {
			cll.closeWindow({
				success: () => {},
				fail: () => {
					console.error('cll close fail.');
				},
			});
		}
  }
};
</script>

<style lang="scss">
	@import './assets/style/transition.scss';
	* {
		box-sizing: border-box;
		-webkit-tap-highlight-color: transparent;
	}
	html, body {
		margin: 0;
		padding: 0;
		user-select: none;
	}

	.che-toast {
		font-size: 12px;
	}

	#app {
	  font-family: Avenir, Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
		overflow: auto;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		font-size: 12px;
		-webkit-overflow-scrolling: touch;
		overflow-scrolling: touch;
		background: #ffffff;

		/* 隐藏百度地图版权 */
		.anchorBL {
			display: none!important;
		}

		.offline-notice {
			width: auto;
			height: 42px;
			line-height: 42px;
			background-color: #FFF1F0;
			font-size: 13px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FF3B30;
			position: fixed;
			top: 10px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 100;
			padding: 0 20px 0 40px;
			border-radius: 8px;
			background-image: url("./assets/img/error.png");
			background-size: 20px;
			background-position: 10px center;
			background-repeat: no-repeat;
		}

    .map-hidden {
      position: absolute;
      left: -9999px;
      opacity: 0;
    }
	}
	.che-dialog-main {
		border-radius: 8px;
	}
	.che-dialog-body {
		text-align: center;
		font-weight: 400;
		color: #333333;
		line-height: 23px;
		padding-bottom: 21px!important;
	}
	.che-dialog-footer {
		border-top: 1px solid #F2F2F2;
	}
	.che-dialog-footer .action {
		line-height: 50px!important;
	}
	.che-dialog-footer .action:not(:last-child) {
		border-right: 1px solid #F2F2F2;
	}

	.ok-toast {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.ok-icon {
		width: 33px;
		height: 33px;
		background-image: url("./assets/img/ok.png");
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100%;
	}

	.ok-test {
		height: 17px;
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 17px;
		margin-top: 12px;
	}
	.custom-vant-dialog {
		border-radius: 10px!important;
	}
</style>
